import { inject, NgModule } from '@angular/core';
import { CanActivateFn, RouterModule, Routes } from '@angular/router';
import { from, isObservable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AuthGuard } from '@app-core/guards/auth/auth.guard';
import { EulaConsentGuard } from '@app-core/guards/eula-consent/eula-consent.guard';
import { GeotabAuthGuard } from '@app-core/guards/geotab-auth/geotab-auth.guard';

import { NewHomeComponent } from './pages/new-home/new-home.component';
import { DynamicGuardsService } from '@app-core/services/dynamic-guards/dynamic-guards.service';

const dynamicGuards: CanActivateFn = (route, state) => {
  const guards = inject(DynamicGuardsService).getGuards();

  if (!guards?.length) {
    return true;
  }

  // Geotab environment: single guard
  if (guards[0] === GeotabAuthGuard) {
    return inject(GeotabAuthGuard).canActivate(route);
  }

  // Non-Geotab: AuthGuard -> EulaConsentGuard
  const authResult = inject(AuthGuard).canActivate(route, state);
  const eulaGuard = inject(EulaConsentGuard);

  if (isObservable(authResult)) {
    return authResult.pipe(switchMap((result) => (result === true ? from(eulaGuard.canActivate()) : of(result))));
  }

  return authResult === true ? eulaGuard.canActivate() : authResult;
};

const routes: Routes = [
  {
    path: 'home',
    canActivate: [dynamicGuards],
    component: NewHomeComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeRoutingModule {}
